module.exports = __webpack_public_path__ + "img/earth.d9343f6.svg";